const venInvStatusConsts = {
  Not_Reviewed: 0,
  Approved: 1,
  Rejected: 2,
  Cancelled: 3,
};
export default venInvStatusConsts;

